import tracker from 'sanitas-tracking'

const triggerType = tracker.triggerType
const trigger = window._sanChatConfig?.trackingDisabled
  ? () => { return true }
  : tracker.trigger

export { trigger, triggerType }
